import type { GetYoutubeVideosByIdQueryVariables } from "@ihr-radioedit/inferno-webapi";
import { getSdk, sdkOpts } from "./sdk";

const sdk = getSdk(sdkOpts());

export const getYoutubeVideosById = (query: GetYoutubeVideosByIdQueryVariables) =>
  sdk!.GetYoutubeVideosByID.queryAsPromise(query).then(
    r => r.data?.sites?.find?.configByLookup?.page?.block?.channel?.youtube || { videos: [] },
  );
